// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16C8q","content":"styles_content__15H58","tableWrap":"styles_tableWrap__2eWAh"};